import { render, staticRenderFns } from "./LocalPagination.vue?vue&type=template&id=31c959f8&scoped=true"
import script from "./LocalPagination.vue?vue&type=script&lang=js"
export * from "./LocalPagination.vue?vue&type=script&lang=js"
import style0 from "./LocalPagination.vue?vue&type=style&index=0&id=31c959f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c959f8",
  null
  
)

export default component.exports